import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Button } from '@mui/material';
import moment from 'moment';

// import SnackbarMessage from '../../../../../common/snackbarMessage';
import Spinner from '../../../../../common/spinner';
import * as types from '../../../../../actions/types';
import {
  resetErrorMessage,
  resetSuccessMessage,
} from '../../../../userOnBoarding/actions/actions';
import {
  orderPay,
  paymentConfirm,
  setRazorpayResponse,
  getRatingFormDataDetails,
  setGuestFormdata,
  accessTokenForGuestUser,
} from '../../../actions/report';
import { setCustomToken } from './../../../../../fireStoreConfig/fireStore';
import { isNull } from '../../../../../utils/helper';
import * as teamTypes from '../../../../../actions/teamTypes';
import '../../../styles/form/guestSummary.css';
import withRouter from 'withRouter';

interface IState {
  imgReq: boolean;
}

interface IProps {
  error: {
    displayMessage: string;
  };
  success: {
    displayMessage: string;
  };
  open: boolean;
  dispatch: Dispatch;
  resetErrorMessage: () => void;
  resetSuccessMessage: () => void;
  orderPay: (instanceId: any, publicId: string, amountKey: string) => void;
  orderPayRequest: boolean;
  orderPaySuccess: boolean;
  orderPayDetails: any;
  paymentConfirmRequest: boolean;
  paymentConfirmSuccess: boolean;
  paymentConfirm: (
    publicId: string,
    instanceId: any,
    orderId: string,
    transactionId: string,
    razorpaySignature: string
  ) => void;
  setRazorpayResponse: (data: any) => void;
  router: any;
  getRatingFormDataDetails: (
    templateId: string,
    instanceId: string,
    publicId: string,
    fields: any,
    isFromForm: boolean
  ) => void;
  getRatingFormDetails: boolean;
  getRatingFormDetailsSpinner: boolean;
  ratingFormDataDetails: any;
  teamDetails: any;
  teamDetailsSuccess: boolean;
  teamDetailsReq: boolean;
  teamDetailsFailure: boolean;
  setGuestFormdata: (guestFormDetails: any) => void;
  accessTokenForGuestUser: (teamId: string, fromGuestUser: boolean) => void;
  guestUserSpinner: boolean;
  guestUserAccessTokenSuccess: boolean;
  guestTemplateId: string;
}

class Summary extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      imgReq: true,
    };
  }

  componentDidMount() {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);
    this.props.setGuestFormdata({});
    this.props.dispatch({
      type: types.RESET_REPORT_DETAILS_ON_TEAM_CHANGE,
    });
    this.props.accessTokenForGuestUser(this.props.router.params.publicId, true);
  }

  componentDidUpdate() {
    if (this.props.guestUserAccessTokenSuccess) {
      this.props.dispatch({
        type: types.RESET_ACCESS_TOKEN_FOR_GUEST_USER_REQUEST,
      });
      this.callGetRatingFormDataDetails();
      setCustomToken(sessionStorage.getItem('accessToken'));
    }
    if (this.props.getRatingFormDetails) {
      this.props.dispatch({
        type: types.RESET_GET_RATING_FORM_DETAILS_REQUEST,
      });
    }
    if (this.props.orderPaySuccess) {
      this.props.dispatch({
        type: types.RESET_ORDER_PAY_REQUEST,
      });
      this.openRazorPayModal();
    }
    if (this.props.paymentConfirmSuccess) {
      this.props.dispatch({
        type: types.RESET_PAYMENT_CONFIRM_REQUEST,
      });
      this.props.router.navigate(
        `/p/kl/${this.props.router.params.publicId}/renew/${this.props.router.params.instanceId}/success`
      );
    }
    if (this.props.teamDetailsSuccess || this.props.teamDetailsFailure) {
      this.props.dispatch({
        type: teamTypes.RESET_GET_TEAM_DETAILS_REQUEST,
      });
      this.resetImgReq();
    }
  }

  scrollToTop = () => {
    setTimeout(() => {
      const element: any = document.getElementById('guest-summary-root');
      element.scrollIntoView({ behavior: 'smooth' });
    }, 1);
  };

  resetImgReq = () => {
    this.setState({ imgReq: false });
  };

  callGetRatingFormDataDetails = () => {
    this.props.getRatingFormDataDetails(
      this.props.guestTemplateId,
      this.props.router.params.instanceId,
      this.props.router.params.publicId,
      [],
      false
    );
  };

  callPaymentConfirm = (response: any) => {
    const data = {
      publicId: this.props.router.params.publicId,
      instanceId: !isNull(this.props.router.params.instanceId)
        ? this.props.router.params.instanceId
        : null,
      orderId: response.razorpay_order_id,
      paymentId: response.razorpay_payment_id,
      signature: response.razorpay_signature,
    };
    this.props.setRazorpayResponse(data);
    this.props.paymentConfirm(
      data.publicId,
      data.instanceId,
      data.orderId,
      data.paymentId,
      data.signature
    );
  };

  getFormData = () => {
    return !isNull(this.props.ratingFormDataDetails) &&
      !isNull(this.props.ratingFormDataDetails.data)
      ? this.props.ratingFormDataDetails.data
      : {};
  };

  openRazorPayModal = () => {
    const data = this.getFormData();
    const options = {
      key: process.env.REACT_APP_KL_RZP_KEY_ID,
      order_id: this.props.orderPayDetails.id,
      handler: (response: any) => this.callPaymentConfirm(response),
      prefill: {
        name: !isNull(data) && !isNull(data['s_name']) ? data['s_name'] : '',
        email:
          !isNull(data) && !isNull(data['s_email_id'])
            ? data['s_email_id']
            : '',
        contact: '',
      },
      theme: {
        color: '#528ff0',
      },
    };
    options.order_id = this.props.orderPayDetails.id;
    const rzp1 = new (window as any).Razorpay(options);
    rzp1.open();
  };

  payNow = () => {
    this.props.orderPay(
      !isNull(this.props.router.params.instanceId)
        ? this.props.router.params.instanceId
        : null,
      this.props.router.params.publicId,
      'price_per_unit'
    );
  };

  handleClose = () => {
    this.props.resetErrorMessage();
    this.props.resetSuccessMessage();
  };

  getExpiryDate = () => {
    const data = this.getFormData();
    const expiryDate =
      !isNull(data) && data['_mo_expiry_date'] ? data['_mo_expiry_date'] : null;
    let expiryDateStr = '';
    if (!isNull(expiryDate))
      expiryDateStr = moment(expiryDate).format('Do MMM YY');
    if (!isNull(data) && data['product_name'].includes('4 Calendar Weeks')) {
      const currenWeekNo = moment().isoWeek();
      const expiryWeekNo = currenWeekNo + 3;
      const expiryDate = moment().isoWeek(expiryWeekNo).endOf('isoWeek');
      expiryDateStr = expiryDate.format('Do MMM YY');
    }
    return expiryDateStr || '';
  };

  renderLogo = () => {
    if (this.state.imgReq) return null;
    else if (
      this.props.teamDetails &&
      this.props.teamDetails.logo1 &&
      this.props.teamDetails.logo1.blobUrl
    )
      return (
        <img
          alt="logo"
          className="logo"
          src={this.props.teamDetails.logo1.blobUrl}
        />
      );
    else return null;
  };

  render() {
    return (
      <div id="guest-summary-root">
        <div className="kl-user-logo-wrapper">{this.renderLogo()}</div>
        <div className="guest-summary-wrapper guest-summary-wrapper-kl">
          {this.props.guestUserSpinner ||
          this.props.teamDetailsReq ||
          this.props.getRatingFormDetailsSpinner ? (
            <Spinner />
          ) : !isNull(this.props.ratingFormDataDetails) &&
            !isNull(this.props.ratingFormDataDetails.data) ? (
            this.props.ratingFormDataDetails.data.status !== 'SUBSCRIBE' ? (
              <p className="kl-no-access-token">
                We are confirming your payment. This may take up to 60 min.
              </p>
            ) : (
              <>
                <div className="guest-summary-header guest-summary-header-kl">
                  <p>Summary</p>
                  <p style={{ fontSize: '16px', paddingTop: '5px' }}>
                    <span
                      style={{ borderBottom: '1px solid red', color: 'red' }}
                    >
                      Important Update:
                    </span>{' '}
                    Clothes per Wash
                  </p>
                  <p style={{ fontSize: '16px' }}>
                    The updated limit is 18 pcs per wash from 4th Jan 2026. If
                    you see 25 pcs, it is a technical glitch please ignore it.
                  </p>
                </div>

                {this.props.orderPayRequest ||
                  (this.props.paymentConfirmRequest && <Spinner />)}
                <div className="guest-summary-content guest-summary-content-kl">
                  <div className="guest-summary-content-wrapper guest-summary-content-wrapper-kl">
                    <div className="name-sku-list-wrapper name-sku-list-wrapper-kl">
                      <div className="sku-list-title-wrapper">
                        <div className="sku-list-wrapper">
                          <p className="title">
                            <i
                              className="fas fa-check"
                              style={{ paddingRight: '10px', color: '#2AC940' }}
                            />
                            1 Item Selected
                          </p>
                          <div className="gsummary-catalog-item-wrapper">
                            <div className="gsummary-code-name-wrapper">
                              <p>{this.getFormData()['product_name']}</p>
                              <p className="price">{`${this.getFormData()['currency']} ${this.getFormData()['price_per_unit']}`}</p>
                            </div>
                          </div>
                          <div className="gsummary-catalog-item-wrapper">
                            <div className="gsummary-code-name-wrapper">
                              <p style={{ width: '100%', textAlign: 'left' }}>
                                Expiry Date: {this.getExpiryDate()}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="button-wrapper">
                        <Button
                          className={`place-order-button ${
                            this.props.orderPayRequest ||
                            isNull(this.props.ratingFormDataDetails)
                              ? 'disabled-button'
                              : ''
                          }`}
                          disabled={isNull(this.props.ratingFormDataDetails)}
                          onClick={this.payNow}
                        >
                          PLACE ORDER
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="kl-powered-by-wrapper-summary">
                    <div className="ne-policy-wrapper">
                      <a
                        href="https://www.klenlaundro.com/"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        Terms and Conditions
                      </a>
                      <a
                        className="kl-email-link"
                        href="mailto:crm@klenlaundro.com"
                      >
                        For clarifications, email crm@klenlaundro.com
                      </a>
                    </div>
                    <div className="kl-powered-by-logo-wrapper-summary">
                      <p>Powered by</p>
                      <img
                        src={require('./../../../../../assets/images/userOnBoarding/logo-big.png')}
                        alt="logo"
                      />
                    </div>
                  </div>
                </div>
              </>
            )
          ) : (
            <p className="kl-no-access-token">You do not have permission</p>
          )}
        </div>
        {/* <SnackbarMessage
          handleClose={this.handleClose}
          message={
            this.props.error.displayMessage || this.props.success.displayMessage
          }
          open={this.props.open}
        /> */}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    open: state.reportReducer.open,
    error: state.reportReducer.error,
    success: state.reportReducer.success,

    orderPayRequest: state.reportReducer.orderPayRequest,
    orderPaySuccess: state.reportReducer.orderPaySuccess,
    orderPayDetails: state.reportReducer.orderPayDetails,

    paymentConfirmRequest: state.reportReducer.paymentConfirmRequest,
    paymentConfirmSuccess: state.reportReducer.paymentConfirmSuccess,

    guestUserSpinner: state.reportReducer.guestUserSpinner,
    guestUserAccessTokenSuccess:
      state.reportReducer.guestUserAccessTokenSuccess,
    guestTemplateId: state.reportReducer.guestTemplateId,

    teamDetails: state.reportReducer.teamDetails,
    teamDetailsSuccess: state.reportReducer.teamDetailsSuccess,
    teamDetailsReq: state.reportReducer.teamDetailsReq,
    teamDetailsFailure: state.reportReducer.teamDetailsFailure,

    getRatingFormDetails: state.reportReducer.getRatingFormDetails,
    getRatingFormDetailsSpinner:
      state.reportReducer.getRatingFormDetailsSpinner,
    ratingFormDataDetails: state.reportReducer.ratingFormDataDetails,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
  ...bindActionCreators(
    {
      resetErrorMessage,
      resetSuccessMessage,
      orderPay,
      paymentConfirm,
      setRazorpayResponse,
      getRatingFormDataDetails,
      setGuestFormdata,
      accessTokenForGuestUser,
    },
    dispatch
  ),
});

export default connect<any, any, any>(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Summary));
